module.exports = __webpack_public_path__ + "img/graph1.67e6b7e8.png";